var map = {
	"./johnson.webp": 363,
	"./mccumber.webp": 364,
	"./smith.webp": 365,
	"./sotu.webp": 366,
	"./sotu_2x.webp": 367,
	"./trump.webp": 368,
	"./vance.webp": 369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 362;